import React from "react";
import { useSelector } from "react-redux";
import { Link as RouterLink } from "react-router-dom";
import { Box } from "../../atoms/Layout/Box/Box";
import { GridCell } from "../../atoms/Layout/GridCell/GridCell";
import { GridRow } from "../../atoms/Layout/GridRow/GridRow";
import { H1, H2 } from "../../atoms/Text/Headings";
import { Game } from "../../models/Game";
import { User } from "../../models/User";
import { Navigation, LinkText } from "../../molecules/Navigation/Navigation";
import Search from "../../molecules/Search/Search";
import styles from "./Header.css";
import { Fa } from "../../atoms/Icons/Fa";
import { DesktopQuery } from "../../atoms/Layout/Responsive";
import { environment } from "../../config/environment";

interface RootState {
  user: User;
  games: Game[];
  router: {
    location: {
      pathname: string;
    };
  };
}

const Header: React.FC = () => {
  const { games, user, pathname } = useSelector((state: RootState) => ({
    games: state.games,
    user: state.user,
    pathname: state.router.location.pathname,
  }));

  const HeaderTag = pathname === "/" ? H1 : H2;

  const renderDebugUser = (user: User) => {
    if (process.env.NODE_ENV !== "production") {
      return user && user.id ? <UserBar>{user.name}</UserBar> : null;
    }
    return null;
  };

  return (
    <Container data-header={true}>
      <HeaderWrapper>
        <MenuRow>
          <MenuCell size={[8, 4.5]}>
            <HeaderTag size="h1" className={styles.headerTag}>
              <a
                href={environment.AARP_PROD_HOST}
                className={styles.headerStyle}
              >
                Games
              </a>
              {renderDebugUser(user)}
            </HeaderTag>
          </MenuCell>

          <MenuCell size={[4, 7.5]}>
            <HeaderContainer>
              <Search games={games} key={pathname}/>
            </HeaderContainer>
          </MenuCell>
        </MenuRow>
      </HeaderWrapper>

      <MenuRow>
        <MenuCell size={[12, 12]}>
          <Navigation />
        </MenuCell>
      </MenuRow>
    </Container>
  );
};

export default Header;

const HeaderContainer = (props: any) => (
  <div className={styles.headerContainer} {...props} />
);

const HeaderWrapper = (props: any) => (
  <div className={styles.headerWrapper} {...props} />
);
const Container = (props: any) => (
  <div className={styles.container} {...props} />
);
const MenuRow = (props: any) => (
  <GridRow className={styles.menuRow} {...props} />
);
const MenuCell = (props: any) => (
  <GridCell className={styles.menuCell} {...props} />
);
const UserBar = (props: any) => <div className={styles.userBar} {...props} />;
const HelpLink = (props: any) => (
  <RouterLink className={styles.desktopHelpLink} {...props} />
);
const HelpIcon = (props: any) => (
  <Fa className={styles.desktopHelpIcon} {...props} />
);
